import { HTMLAttributes, useEffect, useMemo } from 'react'
import { Box } from '@mui/material'
import { useRouter } from 'next/router'

import LandingFooter from '@/components/layout/landing-footer'
import LandingHeader from '@/components/layout/landing-header'
import { LenisProvider } from '@/contexts/lenis'
import { SchemaProvider } from '@/contexts/schema'
import TransitionProvider from '@/contexts/transition/transition-provider'
import { useLocaleStore } from '@/store/locale'

import { WPPageData } from '@/types'

export type LandingLayoutProps = HTMLAttributes<HTMLDivElement> & {
  pageProps?: WPPageData
}

const LandingLayout = ({ pageProps, children, ...props }: LandingLayoutProps) => {
  const router = useRouter()
  const schema = useMemo(() => pageProps?.yoast_head_json?.schema, [pageProps])
  const setCurrentTranslations = useLocaleStore((state) => state.setCurrentTranslations)
  const setCurrentLocale = useLocaleStore((state) => state.setCurrentLocale)

  useEffect(() => {
    setCurrentLocale(router.locale)
  }, [router.locale, setCurrentLocale])

  useEffect(() => {
    setCurrentTranslations(pageProps?.wpml_translations || [])
  }, [pageProps, setCurrentTranslations])

  return (
    <SchemaProvider schema={schema}>
      <LenisProvider {...props}>
        <LandingHeader />
        <TransitionProvider>
          <Box sx={{ pt: (theme) => theme.customSizes.headerHeight }}>{children}</Box>
        </TransitionProvider>
        <LandingFooter />
      </LenisProvider>
    </SchemaProvider>
  )
}

export default LandingLayout
